// The treatment buy box of the PDP A/B test (snippets/pr-buybox.liquid), for
// every product it runs on. Nothing product-specific lives here: which variant
// and which selling plan each card sells comes from the per-product config
// snippet (pr-buybox-{yummies,nectar,oil}.liquid), resolved in Liquid, so a
// re-price or a new plan is a config change, not a script change.
window.PRBuybox = {
  // Exact plan or nothing. PR.allocation falls back to the first allocation of
  // the same kind, which on these products is a generic percentage plan -- a
  // card priced from that would sell something other than what it says. Yummies
  // 180 also carries a 90-count plan ($87) that would price a 6-jar quarter as
  // a 3-jar one.
  cardPlan: function (formula, kind, plans, variants) {
    const card = formula && formula.cards && formula.cards[kind];
    if (!card || !card.variant || !card.plan) return null;
    const variant = variants.find(function (v) {
      return String(v.id) === String(card.variant);
    });
    const record = plans && plans.variants && plans.variants[String(card.variant)];
    const alloc =
      record &&
      record.allocations &&
      record.allocations.find(function (a) {
        return String(a.plan_id) === String(card.plan);
      });
    if (!variant || !alloc || !(alloc.price > 0)) return null;
    return { variant: variant, price: alloc.price, sellingPlan: alloc.plan_id };
  },

  freeShipping: function (cents) {
    return Number(cents) >= window.PRPurchase.FREE_SHIPPING_THRESHOLD_CENTS;
  },

  // What the form submits for the selected card. With no plan (no card on the
  // page could be priced -- e.g. a re-price in Stay AI recreated the plans under
  // new IDs) the button goes dead rather than keeping the last card's variant
  // and plan, or submitting the variant with no plan at all: either would put a
  // one-time or wrong-formula line in the cart under "Subscribe and Save".
  formState: function (plan) {
    if (!plan) return { variantId: null, sellingPlan: '', disabled: true, label: 'Unavailable' };
    const available = !!plan.variant.available;
    return {
      variantId: plan.variant.id,
      sellingPlan: plan.sellingPlan,
      disabled: !available,
      label: available ? 'Subscribe and Save' : 'Sold Out',
    };
  },
};

document.addEventListener('DOMContentLoaded', function () {
  const PR = window.PRPurchase;
  const B = window.PRBuybox;
  const productForm = document.querySelector('.product-single__form');
  if (!productForm || !PR) return;
  const root = productForm.closest('[data-pr-pdp]');
  const box = root && root.querySelector('[data-pr-ybox]');
  if (!box) return;

  const productData = PR.readProduct(productForm);
  const plans = PR.readPlans();
  const configEl = box.querySelector('[data-pr-buybox-config]');
  let config = null;
  try {
    config = configEl && JSON.parse(configEl.textContent);
  } catch (e) {}
  if (!productData || !config || !config.formulas) return;

  const subscriptionIdInput = productForm.querySelector('input[name="selling_plan"]');
  const variantIdInput = productForm.querySelector('[name="id"]');
  const submitButton = productForm.querySelector('.btn--add-to-cart');
  const btnTextElement = submitButton && submitButton.querySelector('.btn__text');
  const orderLine = box.querySelector('.js-ybox-order');
  const onceLink = box.querySelector('.js-ybox-once');
  const cards = Array.prototype.slice.call(box.querySelectorAll('[data-pr-ybox-card]'));
  const offerRadios = productForm.querySelectorAll('[data-pr-offer-radio], input[name="option1"]');
  const unit = box.dataset.unit;
  const units = box.dataset.units;

  // Yummies picks a formula with its pills; Nectar and Oil have one.
  let selectedFormula = 'default';
  const formula = function () {
    return config.formulas[selectedFormula] || config.formulas.default;
  };

  const radioOf = function (card) {
    return card.querySelector('input[name="purchase_option"]');
  };

  const planFor = function (radio) {
    return B.cardPlan(formula(), radio.dataset.planKind, plans, productData.variants);
  };

  // "Regular" is the single unit bought one at a time -- two Sugar-Free jars
  // are $78, one oil bottle $65 -- which is what the advertised tiers are
  // measured against. Per formula: Low Sugar's jar is $35, and striking $78 on
  // it would overstate its saving.
  const fillCard = function (card, plan) {
    const months = parseInt(radioOf(card).dataset.months, 10) || 1;
    const regular = formula().regularMonthly;

    card.querySelector('.js-ybox-monthly').textContent = PR.formatMoneyFlex(Math.round(plan.price / months));

    const struck = card.querySelector('.js-ybox-regular');
    struck.hidden = !(regular > 0);
    if (regular > 0) {
      struck.textContent = PR.formatMoney(regular) + '/mo';
      struck.setAttribute('aria-label', 'Regular price ' + PR.formatMoney(regular) + ' per month');
    }

    const saving = regular * months - plan.price;
    card.querySelector('.js-ybox-savings').textContent =
      regular > 0 && saving > 0 ? 'Save ' + PR.formatMoneyFlex(saving) : '';
    card.querySelector('.js-ybox-free-shipping').hidden = !B.freeShipping(plan.price);
  };

  const updateOnceLink = function () {
    if (!onceLink) return;
    const id = formula().once;
    const variant =
      id &&
      productData.variants.find(function (v) {
        return String(v.id) === String(id);
      });
    onceLink.parentElement.hidden = !variant;
    if (!variant) return;
    onceLink.dataset.variantId = variant.id;
    onceLink.href = onceLink.dataset.cartUrl + '/' + variant.id + ':1';
    onceLink.querySelector('.js-ybox-once-price').textContent = PR.formatMoneyFlex(variant.price);
    onceLink.querySelector('.js-ybox-once-shipping').textContent = B.freeShipping(variant.price)
      ? 'Free Shipping'
      : onceLink.dataset.shippingText;
  };

  const update = function () {
    let firstPriced = null;
    cards.forEach(function (card) {
      const plan = planFor(radioOf(card));
      // A card whose plan is missing is hidden rather than sold at the one-time
      // price -- which is what the form would add with no selling plan set.
      card.hidden = !plan;
      radioOf(card).disabled = !plan;
      if (plan) {
        fillCard(card, plan);
        if (!firstPriced) firstPriced = card;
      }
    });

    let checked = box.querySelector('input[name="purchase_option"]:checked:not(:disabled)');
    if (!checked && firstPriced) {
      checked = radioOf(firstPriced);
      checked.checked = true;
      checked.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const plan = checked ? planFor(checked) : null;
    const state = B.formState(plan);
    if (subscriptionIdInput) subscriptionIdInput.value = state.sellingPlan;
    if (submitButton) {
      submitButton.disabled = state.disabled;
      submitButton.classList.toggle('disabled', state.disabled);
    }
    if (btnTextElement) btnTextElement.textContent = state.label;
    if (!plan) {
      if (orderLine) orderLine.textContent = '';
      updateOnceLink();
      return;
    }

    if (variantIdInput) {
      variantIdInput.value = state.variantId;
      variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const qty = parseInt(checked.dataset.qty, 10) || 1;
    if (orderLine) {
      orderLine.textContent =
        PR.formatMoneyFlex(plan.price) +
        ' today · ' +
        qty +
        ' ' +
        (qty === 1 ? unit : units) +
        ' delivered every ' +
        checked.dataset.weeks +
        ' weeks';
    }

    updateOnceLink();
  };

  if (box.querySelector('[data-pr-offer-radio], input[name="option1"]')) {
    offerRadios.forEach(function (radio) {
      if (radio.checked) selectedFormula = radio.value;
      radio.addEventListener('change', function (e) {
        selectedFormula = e.target.value;
        update();
      });
    });
  }

  cards.forEach(function (card) {
    radioOf(card).addEventListener('change', update);
  });

  if (onceLink) {
    onceLink.addEventListener('click', function (e) {
      const variantId = onceLink.dataset.variantId;
      if (!variantId) return;
      e.preventDefault();
      onceLink.style.pointerEvents = 'none';
      PR.addToCart(variantId, 1)
        .then(function () {
          onceLink.style.pointerEvents = '';
        })
        .catch(function () {
          window.location.href = onceLink.dataset.cartUrl + '/' + variantId + ':1';
        });
    });
  }

  PR.bindSelection(box);
  PR.bindBanner(root);
  PR.bindOfferAccordions(root);
  PR.bindVideos(root);
  update();
});
